// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3EMkf","footer":"ReportModalFilter_footer__3NLm2"};